import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemeChoice } from './theme';

const options: { value: ThemeChoice; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'Hell', icon: Sun },
  { value: 'dark', label: 'Dunkel', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

/** Native radios: arrow keys, one tab stop and the group semantics come with the element. */
export function ThemeSwitch() {
  const { choice, setChoice } = useTheme();
  return <fieldset className="theme-switch">
    <legend>Darstellung</legend>
    <div className="theme-switch-options">{options.map(({ value, label, icon: Icon }) => <label key={value} title={label}>
      <input type="radio" name="portal-theme" value={value} checked={choice === value} onChange={() => setChoice(value)} />
      <Icon size={15} aria-hidden />
      <span>{label}</span>
    </label>)}</div>
  </fieldset>;
}
